module.exports = __webpack_public_path__ + "static/icons/intersport__rewards--icon-9dec8c43caba62ea0131a2d3b7dd95e9.svg";